import { createGlobalStyle, css } from 'styled-components';
import { scrollbar } from '@10d/tend-ui/styling/mixins';
import { colors } from 'constants/colors';
import {
  CONTRACTS_FILTER_SEARCH_CLASSNAME,
  FILTER_SELECTOR_DROPDOWN_CLASSNAME,
  LIST_FILTER_WRAPPER_CLASSNAME,
  REVIEWS_FILTER_SEARCH_CLASSNAME,
} from 'constants/classnames';

const antStyle = css`
  // FORM
  .ant-form,
  .ant-form-item {
    line-height: 1.55;
  }

  // INPUT + DATEPICKER
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button,
  .ant-picker-now {
    display: none !important;
  }

  .ant-picker-time-panel-column:after {
    height: 0 !important;
  }

  .ant-picker-datetime-panel + .ant-picker-footer {
    display: none;
  }

  .ant-input[disabled],
  .ant-picker-input > input[disabled],
  .ant-input::placeholder,
  .ant-picker-input > input::placeholder,
  .ant-select-selection-placeholder,
  .ant-select-selection-item-content,
  .ant-empty-description,
  [data-testid='tend-ui-button'][disabled],
  .ant-checkbox-disabled + span {
    color: ${colors.grayBlue7};
  }
`;

// list filter adaptive
const tendUiFiltersStyle = css`
  .${LIST_FILTER_WRAPPER_CLASSNAME} {
    width: 100%;

    .tend-ui-hot-filters-filter {
      width: 100%;
      max-width: 312px;

      &:has(.tend-ui-checkbox-group) {
        min-width: 368px;
        max-width: 368px;
        width: 368px;
      }

      &:has(.tend-ui-select) {
        max-width: 200px;
      }

      &:has(.${CONTRACTS_FILTER_SEARCH_CLASSNAME}) {
        max-width: 436px;
      }

      &:has(.${REVIEWS_FILTER_SEARCH_CLASSNAME}) {
        max-width: 440px;
      }
    }
  }

  // list filters selectors
  // Dropdown
  .tend-ui-select-dropdown.${FILTER_SELECTOR_DROPDOWN_CLASSNAME} {
    width: 250px !important;
  }
`;

export const GlobalStyle = createGlobalStyle`
  body {
    font-family: "Museo Sans Cyrl", sans-serif;
    font-weight: 500; // на 400 не менять, Егор не одобряет
    font-style: normal;

    // иначе прыгает контент на страницах при открытии
    // дроверов, т.к. он прячет вертикальный скролл
    overflow: hidden auto !important;
  }

  ${antStyle}
  ${tendUiFiltersStyle}
  ${scrollbar}
`;
